const logColors = {
    red12: "color: red; font-size: 12px; font-weight: bold;",
    magenta12: "color: magenta; font-size: 12px; font-weight: bold;",
    orange12: "color: orange; font-size: 12px; font-weight: bold;",
    green12: "color: green; font-size: 12px; font-weight: bold;",
    blue12: "color: blue; font-size: 12px; font-weight: bold;",
    red14: "color: red; font-size: 14px; font-weight: bold;",
    magenta14: "color: magenta; font-size: 14px; font-weight: bold;",
    orange14: "color: orange; font-size: 14px; font-weight: bold;",
    green14: "color: green; font-size: 14px; font-weight: bold;",
    blue14: "color: blue; font-size: 14px; font-weight: bold;",
    red18: "color: red; font-size: 18px; font-weight: bold;",
    magenta18: "color: magenta; font-size: 18px; font-weight: bold;",
    orange18: "color: orange; font-size: 18px; font-weight: bold;",
    green18: "color: green; font-size: 18px; font-weight: bold;",
    blue18: "color: blue; font-size: 18px; font-weight: bold;",
}
export default logColors